var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-container',[_c('b-row',{staticClass:"my-5"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"brand-logo"},[_c('img',{staticClass:"img",attrs:{"src":_setup.Logo}})])]),_c('b-col',{attrs:{"cols":"12"}},[_c('div',{domProps:{"innerHTML":_vm._s(_setup.state)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }